import type {
  CandidateTab,
  ExternalEntityTypeCode,
  ExternalSystemCode,
  LinkConfidence,
  ProductionClassificationValue,
  ProductionLinkStatus,
} from '@quds/shared';
import type { BadgeTone } from '@/components/ui';

export const TAB_LABELS: Record<CandidateTab, string> = {
  candidates: 'Candidates',
  conflicts: 'Conflicts',
  unmatched: 'Unmatched',
  excluded: 'Excluded',
  linked: 'Linked',
};

export const ENTITY_TYPE_LABELS: Record<ExternalEntityTypeCode, string> = {
  TENANT: 'Cloud tenant',
  BRANCH: 'Cloud branch',
  UPDATE_CUSTOMER: 'Updater customer',
  UPDATE_DEVICE: 'Updater installation',
  LICENSE_DEVICE: 'License hardware ID',
  OFFLINE_LICENSE: 'Offline license',
  OWNER_ACCOUNT: 'Owner mobile account',
};

export const SYSTEM_LABELS: Record<ExternalSystemCode, string> = {
  quds_pos_cloud: 'Cloud',
  quds_updater: 'Updater',
  quds_licensing: 'License',
  quds_owner_mobile: 'Owner',
};

export const CONFIDENCE_LABELS: Record<LinkConfidence, string> = {
  high: 'HIGH',
  medium: 'MEDIUM',
  low: 'LOW',
  conflict: 'CONFLICT',
  manual: 'MANUAL',
};

export const CONFIDENCE_TONES: Record<LinkConfidence, BadgeTone> = {
  high: 'success',
  medium: 'warning',
  low: 'muted',
  conflict: 'danger',
  manual: 'primary',
};

export const CLASSIFICATION_LABELS: Record<ProductionClassificationValue, string> = {
  unknown: 'Unknown',
  real: 'Real',
  test: 'Test',
  developer: 'Developer',
};

export const CATEGORY_LABELS: Record<'PHARMACY' | 'SUPERMARKET' | 'RESTAURANT' | 'OTHER', string> = {
  PHARMACY: 'Pharmacy',
  SUPERMARKET: 'Supermarket',
  RESTAURANT: 'Restaurant',
  OTHER: 'Other',
};

export const LINK_STATUS_TONES: Record<ProductionLinkStatus, BadgeTone> = {
  Linked: 'success',
  'Partially Linked': 'warning',
  'Not Linked': 'neutral',
  Conflict: 'danger',
};

export function itemKey(ref: { system: string; entityType: string; externalId: string }): string {
  return `${ref.system}:${ref.entityType}:${ref.externalId}`;
}

/** Mask middle of an id; full value available on click / title. */
export function maskId(id: string): string {
  if (id.length <= 10) return id;
  return `${id.slice(0, 6)}…${id.slice(-4)}`;
}
